var map = {
	"./excel.png": "2074",
	"./file.png": "bbff",
	"./img.png": "fa5d",
	"./left-arrow.png": "e0cf",
	"./pdf.png": "06ee",
	"./show_more.png": "5ebc",
	"./word.png": "e458"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57bf";